/**
 * Coarse device classification from the user agent.
 * Prefer specific platforms (iphone, android) over generic mobile/desktop.
 * @returns {'iphone' | 'ipad' | 'android' | 'android_tablet' | 'mobile' | 'desktop'}
 */
const getDeviceType = () => {
  if (typeof navigator === 'undefined') return 'desktop';

  const ua = navigator.userAgent || '';

  if (/iPhone/i.test(ua)) return 'iphone';
  // iPadOS 13+ may report as Macintosh with touch
  if (/iPad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'ipad';
  }
  if (/Android/i.test(ua)) {
    return /Mobile/i.test(ua) ? 'android' : 'android_tablet';
  }
  if (/Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return 'mobile';

  return 'desktop';
};

/**
 * Coarse OS classification from the user agent.
 * @returns {'ios' | 'android' | 'macos' | 'windows' | 'linux' | 'chromeos' | 'other'}
 */
const getDeviceOs = () => {
  if (typeof navigator === 'undefined') return 'other';

  const ua = navigator.userAgent || '';

  if (/iPhone|iPad|iPod/i.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'ios';
  }
  if (/Android/i.test(ua)) return 'android';
  if (/CrOS/i.test(ua)) return 'chromeos';
  if (/Win/i.test(ua)) return 'windows';
  if (/Mac/i.test(ua)) return 'macos';
  if (/Linux/i.test(ua)) return 'linux';

  return 'other';
};

export { getDeviceType, getDeviceOs };
export default getDeviceType;
